export default {
    getEvents(state) {
        return state.events;
    },
    getRegistrationList(state) {
        if (state.registrationList) {
            return state.registrationList.sort((a, b) => {
                return a.id - b.id
            });
        }
    }
}